export default __webpack_public_path__ + "static/media/CK.fe12a4e9.svg";